import { GET_ORDER_SHOPS } from "../Actions/types";

const initialState = {
  order_shops: [],
  total: 0
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ORDER_SHOPS:
      return {
        ...state,
        order_shops: action.payload.shops,
        total: action.payload.total
      };
    default:
      return state;
  }
}